import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedComponent } from './shared.component';
import { NavigationComponent } from './navigation/navigation.component';
import {Tabs} from './tab/tabs.component';
import {Tab} from "./tab/tab.component";
import {Gravatar} from "./gravatar/gravatar.directive";
import {RouterModule} from "@angular/router";
import {AppModalComponent} from "./modal/modal";
import {SpinnerComponent} from "./spinner/spinner.component";
import {RectLoaderComponent} from "./spinner/rect-loader.components";
import {DropdownComponent} from "./navigation/dropdown.component";
import {ShowHideInput} from "./change-input.directive";
import {CapitalizeFirstPipe} from "./capitalizefirst.pipe";
import {ConfirmationPopup} from "./modal/confirmation.popup";
import {ClipboardDirective} from "./clipboard/clipboard";
import {TruncatePipe} from "./truncateChars.pipe";
import { PaginationComponent } from './pagination/pagination.component';
import { Canbedisabled } from './canbedisabled.directive';
import {QRCodeComponent} from "./qr-code/qr-code";
import { FormControl} from "./form/form.control";
import {NumberOnly} from "./number-only.directive";
import {DatexPipe} from "./ie-workaround/date.pipe";
import {CAROUSEL_DIRECTIVES} from "./carousel/carousel.component";
import { SearchDropdownComponent } from './search-dropdown/search-dropdown.component';
import { DropdownDirective } from './search-dropdown/dropdown.directive';
import { FilterPipe } from './search-dropdown/filter.pipe';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DropDownOption} from '../rules/new-rule/condition-col/condition-col.component';
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule
  ],
  declarations: [
    SharedComponent,
    NavigationComponent,
    Tabs,
    Tab,
    Gravatar,
    AppModalComponent,
    SpinnerComponent,
    RectLoaderComponent,
    DropdownComponent,
    ShowHideInput,
    CapitalizeFirstPipe,
    ConfirmationPopup,
    ClipboardDirective,
    TruncatePipe,
    PaginationComponent,
    Canbedisabled,
    QRCodeComponent,
    FormControl,
    NumberOnly,
    DatexPipe,
    CAROUSEL_DIRECTIVES,
    SearchDropdownComponent,
    DropdownDirective,
    FilterPipe

  ],
  exports: [
    NavigationComponent,
    Tabs,
    Tab,
    Gravatar,
    AppModalComponent,
    SpinnerComponent,
    RectLoaderComponent,
    DropdownComponent,
    ShowHideInput,
    CapitalizeFirstPipe,
    ConfirmationPopup,
    ClipboardDirective,
    TruncatePipe,
    PaginationComponent,
    Canbedisabled,
    QRCodeComponent,
    FormControl,
    NumberOnly,
    DatexPipe,
    CAROUSEL_DIRECTIVES,
    SearchDropdownComponent


  ],
  entryComponents: [
    SearchDropdownComponent
  ],
  providers: [DropDownOption]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts